import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { Text } from '@wartek-id/text-v1'

import CardIndicator from './CardIndicator'

import type { TPraktikKinerjaItem } from 'types/kinerja-ps-pegawai'

type PraktikKinerjaProps = {
  praktikKinerjaData?: TPraktikKinerjaItem[]
}

const PraktikKinerja = ({ praktikKinerjaData = [] }: PraktikKinerjaProps) => {
  const { control } = useFormContext()

  if (praktikKinerjaData.length === 0) {
    return null
  }

  return (
    <div className="space-y-6">
      <Text variant="heading-lg">
        Berikut 4 indikator yang menjadi fokus peningkatan kinerja Anda
      </Text>

      <Controller
        control={control}
        name="selectedPraktikKinerjaIds"
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              {praktikKinerjaData.map((item, index) => (
                <CardIndicator
                  {...item}
                  key={index}
                  isActive={value.includes(item.id)}
                  isDisabled
                  onClick={() => onChange(item.id)}
                />
              ))}
            </>
          )
        }}
      />
    </div>
  )
}

export default PraktikKinerja
